export default {
	QUEUED: 'queued',
	UPLOADING: 'uploading',
	PROCESSING: 'processing',
	COMPLETED: 'completed',
	FAILED: 'failed',
};
